import { VREditorPanel } from './editorpanel.js';
import { VRBoard } from '../ver-assets/board.js';
import { VRPerson } from '../ver-assets/person.js';
import { VRHotspot } from '../ver-assets/hotspots.js';
import { connectToParent } from 'penpal';
import { VRToolbar } from './toolbar-panel.js';
import { UndoRedo } from './undo-redo.js';
import { VRCustomOverlay } from '../ver-assets/custom-overlay.js';
import { AlertModal } from './alert-modal.js';

export class VREditor {
  static PublishStatus = {
    DRAFT: 0,
    PUBLISHED: 1
  };

  constructor (vr) {
    this.vr = vr;
    this.objects = [];
    this.localEditor = false;
    this.apiUrl = process.env.API_URL;
    this.undoRedo = new UndoRedo();

    if (
      window.location.search.includes('dev=true') ||
      window.location.origin.includes('communityanalytics.local')
    ) {
      this.localEditor = true;
      this.apiUrl = process.env.LOCAL_API_URL;
      this.cmsUrl = process.env.LOCAL_CMS_URL;
    } else {
      this.apiUrl = process.env.API_URL;
      this.cmsUrl = process.env.CMS_URL;
    }

    if (!this.vr.localDev || this.vr.localDev === undefined) {
      this.initPenpal((auth, contentId) => {
        this.getUser(auth, (devMode) =>
          this.loadConfig(auth, contentId, devMode)
        );
      });
    } else {
      // move the auth and contentId into a config file possibly
      const auth = process.env.AUTH_KEY;
      this.getUser(auth, (devMode) =>
        this.loadConfig(auth, this.vr.contentId, devMode)
      );
      // this.init(this.vr.getJsonConfig());
    }

    if (this.contentSlug !== undefined || this.contentSlug !== null) {
      this.slugValid = true;
    }
  }

  init (options) {
    this.options = options;
    this.panel = new VREditorPanel(this.vr, this);
    this.alertModal = new AlertModal(this.vr, this);
    this.toolbar = new VRToolbar(this.vr, this);
  }

  // have a look here for the transition issue
  setScene (scene) {
    // Mouse stuff
    scene.getContainer().on(
      'mousedown',
      function () {
        this.unselectAll();
      }.bind(this)
    );

    scene.getContainer().on(
      'touchstart',
      function () {
        this.unselectAll();
      }.bind(this)
    );

    scene.getContainer().mouseup(
      function () {
        this.objects.forEach(function (o) {
          o.stopMoving();
        });

        this.vr.enableMove(true);
        this.objectMoving = false;
      }.bind(this)
    );

    scene.getContainer().mousemove(
      function (event) {
        this.objects.forEach(
          function (o) {
            if (o.isMoving()) {
              if (this.vr.insetMap != null) { this.vr.insetMap.moveAsset(o.options); }
              this.objectMoving = true;
              o.mousemove(event);
            }
          }.bind(this)
        );

        if (!this.objectMoving) return;

        event.stopPropagation();
        this.vr.scene.sortOverlays();
        this.vr.enableMove(false);
      }.bind(this)
    );
  }

  setRoom (roomId) {
    const room = this.vr.getRoomAsset(roomId);
    this.setImage(
      'https://ca-v2.s3.ap-southeast-2.amazonaws.com/ca/virtual-editor/assets/rooms/room_' +
        room.id +
        '_{daynight}_{quality}.jpg'
    );
    this.setRoomAsset(room);
  }

  setRoomAsset (room) {
    this.vr.setRoom(room.id);

    this.objects.forEach(
      function (o) {
        o.onRoomChange(room);
      }
    );
  }

  setImage (media) {
    if (this.vr.options.scenes[0]) {
      this.vr.options.scenes[0].media = media;
      this.vr.getCurrentScene().loadImage(media, null, null, false);
    } else {
      console.error('Scenes Empty. This has been reset');
    }
  }

  setShowPopupPreview (isShowing) {
    this.isShowingPopupPreview = isShowing;
    if (isShowing) {
      this.toolbar.hideToolbarButtons();
      this.toolbar.showClosePopup();
    } else {
      this.toolbar.showToolbarButtons();
      this.toolbar.hideClosePopup();
    }
  }

  destroyPopupPreview () {
    if (this.currentPreviewPopup !== undefined) {
      this.currentPreviewPopup.remove();
      this.setShowPopupPreview(false);
    }
  }

  openPanel (open) {
    this.editing = open;
    this.panel.open(open);
    if (open) $(document.body).addClass('ca-vr_editor');
    else $(document.body).removeClass('ca-vr_editor');

    if (!open) this.unselectAll();
  }

  togglePanel () {
    this.openPanel(!this.editing);
  }

  openSubPanel (object) {
    let activePanel;
    if (object instanceof VRPerson) {
      activePanel = this.panel.openSubPanel('people', true);
    } else if (object instanceof VRBoard) {
      activePanel = this.panel.openSubPanel('boards', true);
    } else if (object instanceof VRHotspot) {
      activePanel = this.panel.openSubPanel('hotspots', true);
    } else if (object instanceof VRCustomOverlay) {
      activePanel = this.panel.openSubPanel('custom-overlays', true);
    } else {
      activePanel = null;
    }

    if (activePanel) {
      activePanel.setObject(object, true);
    }
  }

  closeSubPanel () {
    this.panel.setObject(null);
  }

  isEditing () {
    return this.editing;
  }

  addObject (object) {
    this.objects.push(object);
    this.saveChanges();
  }

  unselectAll () {
    if (this.selected === undefined || this.selected === null) {
      return;
    }
    this.selected.setEditMode(false);
    this.selected = null;
    this.saveChanges();
    if (this.vr.insetMap != null) {
      this.vr.insetMap.setActiveAsset(null);
    }
  }

  select (s) {
    this.unselectAll();
    if (s !== undefined) {
      console.log(s.id);
      console.log(s);
      this.selected = s;
      this.selected.setEditMode(true);
      this.saveChanges();
      if (this.vr.insetMap != null) this.vr.insetMap.setActiveAsset(s.options);
    } else {
      console.error('Something is missing from the Select function');
    }
  }

  deleteObject (obj) {
    this.objects.splice(this.objects.indexOf(obj), 1);
    this.vr.removeAsset(obj);
  }

  autoAddBoards () {
    this.vr.lookAt(
      this.vr.getYaw() - 360,
      this.vr.getPitch(),
      this.vr.getFov(),
      10000,
      false,
      false
    );

    for (let b = 0, yaw = this.vr.getYaw(); b < 14; b++, yaw += 25.5) {
      const board = this.vr.addBoard(yaw, false);
      this.addObject(board);
      board.hide();

      setTimeout(
        function () {
          this.show();
        }.bind(board),
        300 * b
      );
    }
  }

  initPenpal (callback) {
    this.vr.showLoading('Connecting to CMS...');
    this.penpalCon = connectToParent({
      targetOrigin: VREditor.CMS_URL
    });
    this.penpalCon.promise.then((parent) => {
      this.penpalParent = parent;
      this.penpalParent.editorGetToken().then((r) => {
        callback(r.authToken, r.contentUUID);
      });
    });
  }

  save (status, options) {
    this.vr.showLoading(
      status === VREditor.PublishStatus.DRAFT
        ? 'Saving draft...'
        : 'Publishing...'
    );

    if (((this.contentName !== undefined || this.contentName !== '' || this.contentName !== null)) && this.slugValid) {
      this.vr.options.roomTitleFirstSaved = true;
    } else {
      this.vr.options.roomTitleFirstSaved = false;
    }
    const request = {
      project_id: this.projectId,
      name: this.contentName,
      slug: this.contentSlug,
      published_status: VREditor.PublishStatus.DRAFT ? 'draft' : 'published',
      type: 'ver',
      metadata: JSON.parse(options || this.vr.getJsonConfig())
    };
    console.log(request.metadata);

    if (this.contentSlug && this.slugValid) {
      $.ajax({
        type: 'PATCH',
        url: `${this.apiUrl}/contents/${this.contentId}`,
        headers: {
          Authorization: 'Bearer ' + this.authToken,
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        data: JSON.stringify(request)
      })
        .done((response) => {
          console.log(response);
          // get response
          // get portal preview url/key here
          if (status === 0) {
            // alert('Saving successful. VER is currently a draft');
            this.alertModal.setSuccessState(true);
            this.alertModal.setAlertMessage('Saving successful. VER is currently a draft');
            this.alertModal.setAlertCTAButtons({
              buttonCount: 1,
              buttons: [
                {
                  type: 'confirm',
                  text: 'OK'
                }
              ]
            });
            this.alertModal.show();
          } else {
            // alert('Saving successful. VER is currently published');
            this.alertModal.setSuccessState('confirm');
            this.alertModal.setAlertMessage('Saving successful. VER is currently published, would you like to view the room?');
            this.alertModal.setAlertCTAButtons({
              buttonCount: 2,
              buttons: [
                {
                  type: 'confirm',
                  text: 'Take me to the Preview Room',
                  link: response.data.portal_preview_url
                },
                {
                  type: 'decline',
                  text: "I'm good, leave me here"
                }
              ]
            });
            this.alertModal.show();
          }
        })
        .fail((e) => {
          alert(e.responseJSON.message);
        })
        .always(() => {
          this.vr.hideLoading();
        });
    } else {
      console.log(this.contentSlug, this.slugValid);
      // alert('Slug is invalid and is already used. Please choose a slug that is unique and try again.');
      this.alertModal.setSuccessState('error');
      this.alertModal.setAlertMessage('Slug is invalid and is already used. Please choose a slug that is unique and try again');
      this.alertModal.setAlertCTAButtons({
        buttonCount: 1,
        buttons: [
          {
            type: 'confirm',
            text: 'OK'
          }
        ]
      });
      this.alertModal.show();
      this.vr.hideLoading();
    }
  }

  loadConfig (auth, contentId, devMode) {
    this.authToken = auth;
    this.contentId = contentId;
    this.devMode = devMode;
    this.vr.showLoading('Loading room config...');
    $.ajax({
      url: `${this.apiUrl}/contents/${contentId}`,
      headers: {
        Authorization: 'Bearer ' + auth,
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    })
      .done((data) => {
        const roomData = data.data;
        console.log(roomData);
        this.projectId = roomData.project_id;
        this.clientSlug = roomData.project.client.base_url;
        this.projectSlug = roomData.project.slug;
        this.contentName = roomData.name;
        this.contentSlug = roomData.slug;

        const options = roomData.metadata;
        options.devMode = devMode;
        options.caEditor = true;
        options.editor = true;

        this.vr.init(options, true);
        this.setPublishable();
      })
      .fail((e) => {
        alert(e.responseJSON.message);
      })
      .always(() => {
        this.vr.hideLoading();
      });
  }

  getUser (auth, callback) {
    this.vr.showLoading('Authenticating...');
    this.auth = auth;
    $.ajax({
      url: `${this.apiUrl}/auth/user`,
      headers: {
        Authorization: 'Bearer ' + auth,
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    })
      .done((data) => {
        let role;
        let devMode;
        if (data.data.roles !== undefined && data.data.roles !== null) {
          role = data.data.roles[0];
          // if (data.data.roles[0] === 'super') {
          //   devMode = true;
          // } else {
          //   devMode = data.roles.includes('super');
          // }
          if (role !== undefined && role === 'super') {
            devMode = true;
          }
        }

        this.fetchUserUUID();
        callback(devMode);
      })
      .fail((e) => {
        if (e.responseJSON) {
          alert(e.responseJSON.message);
        }
      })
      .always(() => {});
  }

  getProjectId () {
    return this.projectId;
  }

  getClientId () {
    return this.clientId;
  }

  getAuth () {
    return this.auth;
  }

  getUserUUID () {
    return this.userUUID;
  }

  fetchUserUUID () {
    $.ajax({
      url: `${this.apiUrl}/auth/user`,
      headers: {
        Authorization: 'Bearer ' + this.auth,
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    }).done((data) => {
      this.userUUID = data.data.uuid;
      this.vr.hideLoading();
    }).fail((e) => {
      if (e.responseJSON) {
        alert(e.responseJSON.message);
      }
    }).always(() => {});
  }

  setPublishable () {
    if (this.penpalCon) {
      this.penpalParent.editorIsPublishable(true).then(() => {});
    }
  }

  saveChanges () {
    if (this.penpalCon) {
      this.penpalParent
        .editorContentUpdate(this.vr.getJsonConfig())
        .then(() => {});
    }
  }

  openMediaPicker (callback) {
    if (this.penpalCon) {
      this.penpalParent.editorGetMedia().then((r) => {
        // the below must be a uid, do not pass an object into the api
        console.log(r);
        let dataToUpload;
        if (r !== undefined && r !== null) {
          this.vr.showLoading('Loading media...');
          dataToUpload = r[0].id;
          $.ajax({
            url: `${this.apiUrl}/media/${dataToUpload}`,
            headers: {
              Authorization: 'Bearer ' + this.authToken,
              'Content-Type': 'application/json',
              Accept: 'application/json'
            }
          })
            .done((data) => {
              callback(data);
            })
            .fail((e) => {
              alert(e.responseJSON.message);
            })
            .always(() => {
              this.vr.hideLoading();
            });
        }
      });
    }
  }
}
